import React from 'react';
import { motion } from 'framer-motion';
import { Book, Zap, Smartphone, Target, ArrowRight } from 'lucide-react';
export function PricingSection() {
  const details = [{
    icon: <Book className="w-5 h-5 text-blue-400" data-id="element-174" />,
    text: '📖 Formato: e-book digital'
  }, {
    icon: <Zap className="w-5 h-5 text-blue-400" data-id="element-175" />,
    text: '⚡ Acceso: inmediato tras el pago'
  }, {
    icon: <Smartphone className="w-5 h-5 text-blue-400" data-id="element-176" />,
    text: '📱 Ideal para: Meta Ads (Facebook/Instagram)'
  }, {
    icon: <Target className="w-5 h-5 text-blue-400" data-id="element-177" />,
    text: '🎯 Para: agencias, infoproductores, ecommerce, coaches y negocios locales'
  }];
  return <section id="pricing" className="py-24 px-4 bg-[#0a0a0f] relative" data-id="element-178">
      {/* Background glow for emphasis */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-179"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-b from-[#1a1a24] to-[#15151e] border border-gray-700 rounded-3xl p-8 md:p-12 shadow-2xl text-center" data-id="element-181">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-182">
            Acceso inmediato por solo
          </h2>
          <div className="text-6xl md:text-7xl font-black text-amber-500 mb-8 tracking-tighter" data-id="element-183">
            $6.36 <span className="text-2xl text-amber-500/70" data-id="element-184">USD</span>
          </div>

          <div className="bg-[#0a0a0f] rounded-xl p-6 mb-8 text-left border border-gray-800" data-id="element-185">
            <ul className="space-y-4" data-id="element-186">
              {details.map((detail, index) => <li key={index} className="flex items-center text-gray-300" data-id="element-187">
                  <span className="text-lg" data-id="element-188">{detail.text}</span>
                </li>)}
            </ul>
          </div>

          <p className="text-xl text-gray-300 mb-8 italic" data-id="element-189">
            "Porque cada día que anuncias sin este mapa, estás pagando por
            aprendizaje… otra vez."
          </p>

          <h3 className="text-2xl font-bold text-white mb-6" data-id="element-190">
            ¿Estás listo para dejar de botar dinero?
          </h3>

          <p className="text-gray-400 mb-4" data-id="element-191">
            👇 Haz clic abajo y descárgalo ahora
          </p>

          <motion.a href="https://pay.hotmart.com/J105202862M" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full py-5 px-8 text-xl md:text-2xl font-black text-white bg-amber-500 rounded-xl hover:bg-amber-400 transition-all duration-300 shadow-[0_0_30px_rgba(245,158,11,0.3)] hover:shadow-[0_0_40px_rgba(245,158,11,0.5)] flex items-center justify-center group" data-id="element-192">
            SÍ, QUIERO EL E-BOOK POR $6.36 USD
            <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-193" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}